var map = {
	"./activityBg.png": 22567,
	"./arrow-left-blue.svg": 90475,
	"./arrow-left-grey.svg": 72391,
	"./arrow-right-blue.svg": 18859,
	"./arrow-right-grey.svg": 32643,
	"./calendar.png": 48754,
	"./index_banner_1.png": 76330,
	"./index_banner_2.png": 87436,
	"./index_banner_3.png": 35880,
	"./index_banner_4.png": 73999,
	"./mindteach.png": 66995,
	"./mindteach001.png": 27285,
	"./part-active-title.svg": 68266,
	"./part-ai-right-title.png": 54881,
	"./part-ai-right-type.svg": 63255,
	"./part-expert-title.svg": 73635,
	"./part-school-title.svg": 56384,
	"./part-teach-title.svg": 55889,
	"./part_ai_top_1.png": 53425,
	"./part_ai_top_2.png": 15575,
	"./part_ai_top_3.png": 32202,
	"./part_ai_top_4.png": 54853,
	"./part_ai_top_5.png": 91408,
	"./part_ai_top_6.png": 62653,
	"./part_ai_topv2.png": 91068,
	"./recommendBg.png": 73903,
	"./search_icon.svg": 48165,
	"./subbg.png": 809,
	"./swbg.png": 79899,
	"./teacherBg.png": 70645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46211;